import { isPermissionPresent } from "../../../utilities/generalUtility";
import K from "../../../utilities/constants";
import { DefaultColumnOptions } from "../../../hooks/useDataGrid/options";
import { EditIconButton } from "../../../common/components/iconButton/editIconButton";

export const columns = (onEdit, roles) => [
  DefaultColumnOptions.Id,
  {
    headerName: "Client",
    field: "clientName",
    sortable: true,
    tooltipField: "clientName",
  },
  {
    headerName: "Description",
    field: "title",
    tooltipField: "title",
    sortable: true,
    minWidth: 300,
  },
  {
    headerName: "Billing Type Name",
    field: "billingTypeName",
    tooltipField: "billingTypeName",
    sortable: true,
    minWidth: 200,
  },
  {
    headerName: "Currency",
    field: "currency",
    tooltipField: "currency",
    sortable: true,
  },
  {
    headerName: "Billed Amount",
    field: "duplicateAmount",
    tooltipField: "duplicateAmount",
    sortable: true,
  },
  {
    headerName: "Due Date",
    field: "dueDate",
    tooltipField: "dueDate",
    sortable: true,
    sort: "asc",
  },
  {
    headerName: "Active?",
    field: "isActive",
    tooltipField: "isActive",
    sortable: true,
  },
  {
    headerName: "Repeat",
    field: "isInfinite",
    sortable: true,
    minWidth: 200,
    tooltipField: "isInfinite",
  },
  {
    ...DefaultColumnOptions.Actions,
    hide: !isPermissionPresent(K.Permissions.EditScheduledBillings, roles),
    cellRenderer: (params) => (
      <>
        {isPermissionPresent(K.Permissions.EditScheduledBillings, roles) && (
          <EditIconButton onClick={() => onEdit(params.data)} />
        )}
      </>
    ),
  },
];
